<template>
  <br>
  <div style="display: flex; justify-content: space-between; background-color: #f0f0f0; padding: 10px; border-radius: 5px;">
    <h4 style="margin: 0;">Paso 1: ¿Cómo quieres empezar? Elige tu plan</h4>
    <h4 style="margin: 0;">
      <span class="badge bg-primary">1</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
      <span class="badge bg-primary">&nbsp;</span>
    </h4>
  </div>
  <hr>
  <div class="progress">
    <div class="progress-bar" role="progressbar" aria-label="Basic example" style="width: 20%" aria-valuenow="20"
      aria-valuemin="0" aria-valuemax="100"></div>
  </div>
  <br>
  <br>
  <div style="font-size: 20px; text-align: justify;">
    <strong>¡Bienvenido a nuestra plataforma de registro de atenciones médicas!</strong>
    <br>
    Por favor, seleccione el plan que mejor se adapte a sus necesidades y requisitos. 
    Cada plan ofrece una variedad de características diseñadas para satisfacer diferentes niveles de uso y demandas. 
    ¡Explora nuestras opciones a continuación y comienza tu viaje con nosotros hoy mismo!
  </div>
  <section class="pricing py-5">
    <p style="color: blue; font-size: 28px; font-weight: bold;">Planes Mensuales</p>
    <div class="container">
      <div class="row" style="justify-content: center; align-items: center; text-align: center;">
        <!-- Free Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightgray; padding: 5px;">
                Gratis
              </h5>
              <h6 class="card-price text-center">$0<span class="period">/15 días</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 50 Pacientes</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 100 Atenciones</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>1 Usuario</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Reportes Básicos</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Dashboards Avanzados</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Soporte Telefónico Dedicado</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="registrarGratis()">Registrar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Basic Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightyellow; padding: 5px;">
                Básico
              </h5>
              <h6 class="card-price text-center">$10<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 500 Pacientes</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 1,000 Atenciones</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 5 Usuarios</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Reportes Básicos</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Dashboards Interactivos</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Soporte Telefónico Dedicado</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="registrarBasico()">Registrar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Plus Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightpink; padding: 5px;">
                Plus
              </h5>
              <h6 class="card-price text-center">$20<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 1,000 Pacientes</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 2,500 Atenciones</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 10 Usuarios</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Dashboards Interactivos</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Soporte Telefónico Dedicado</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="registrarPlus()">Registrar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Pro Tier -->
        <div class="col-lg-3">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightskyblue; padding: 5px;">
                Pro
              </h5>
              <h6 class="card-price text-center">$45<span class="period">/mes</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Pacientes Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Atenciones Ilimitadas</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Usuarios Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Dashboards Avanzados e Interactivos</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Soporte Telefónico Dedicado</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="registrarPro()">Registrar ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>  

  <section class="pricing py-5">
    <p style="color: blue; font-size: 28px; font-weight: bold;">Planes Anuales con 10% de Descuento</p>
    <div class="container">
      <div class="row" style="justify-content: center; align-items: center; text-align: center;">
        <!-- Silver Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightyellow; padding: 5px;">
                Silver
              </h5>
              <h6 class="card-price text-center">$108<span class="period">/año</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 500 Pacientes</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 1,000 Atenciones</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 5 Usuarios</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Reportes Básicos</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Dashboards Interactivos</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Soporte Telefónico Dedicado</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="registrarSilver()">Registrar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Gold Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightpink; padding: 5px;">
                Gold
              </h5>
              <h6 class="card-price text-center">$216<span class="period">/año</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 1,000 Pacientes</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 2,500 Atenciones</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Hasta 10 Usuarios</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Dashboards Interactivos</li>
                <li class="text-muted"><span class="fa-li"><i class="fas fa-times"></i></span>Soporte Telefónico Dedicado</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="registrarGold()">Registrar ></button>
              </div>
            </div>
          </div>
        </div>
        <!-- Platinum Tier -->
        <div class="col-lg-3">
          <div class="card mb-5 mb-lg-0">
            <div class="card-body">
              <h5 class="card-title text-muted text-uppercase text-center" style="background-color: lightskyblue; padding: 5px;">
                Platinum
              </h5>
              <h6 class="card-price text-center">$486<span class="period">/año</span></h6>
              <hr>
              <ul class="fa-ul">
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Pacientes Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Atenciones Ilimitadas</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Usuarios Ilimitados</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Dashboards Avanzados e Interactivos</li>
                <li><span class="fa-li"><i class="fas fa-check"></i></span>Soporte Telefónico Dedicado</li>
              </ul>
              <div class="d-grid">
                <button type="submit" class="btn btn-primary mb-3" @click="registrarPlatinum()">Registrar ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data() {
    return {
      email: ""
    }
  },
  methods: {
    login() {
      this.$router.push('Login')
    },
    modal() {
      this.$router.push('App')
    },
    registrarGratis() {
      window.sessionStorage.setItem("nombrePlan", "Gratis");
      window.sessionStorage.setItem("idPlan", "1");
      this.$router.push('Registro02TC')
    },
    registrarBasico() {
      window.sessionStorage.setItem("nombrePlan", "Básico");
      window.sessionStorage.setItem("idPlan", "2");
      this.$router.push('Registro02TC')
    },
    registrarPlus() {
      window.sessionStorage.setItem("nombrePlan", "Plus");
      window.sessionStorage.setItem("idPlan", "3");
      this.$router.push('Registro02TC')
    },
    registrarPro() {
      window.sessionStorage.setItem("nombrePlan", "Pro");
      window.sessionStorage.setItem("idPlan", "4");
      this.$router.push('Registro02TC')
    },
    registrarSilver() {
      window.sessionStorage.setItem("nombrePlan", "Silver");
      window.sessionStorage.setItem("idPlan", "5");
      this.$router.push('Registro02TC')
    },
    registrarGold() {
      window.sessionStorage.setItem("nombrePlan", "Gold");
      window.sessionStorage.setItem("idPlan", "6");
      this.$router.push('Registro02TC')
    },
    registrarPlatinum() {
      window.sessionStorage.setItem("nombrePlan", "Platinum");
      window.sessionStorage.setItem("idPlan", "7");
      this.$router.push('Registro02TC')
    },
  }
}
</script>
<style src="@/assets/css/tarjetas.css" scoped></style>
